export function maskPhone(phone) {
  if (!phone || phone.length < 7) return phone || '-'
  return `${phone.slice(0, 3)}****${phone.slice(-4)}`
}

export function formatUserDate(value) {
  if (!value) return '-'
  const text = String(value)
  return text.length >= 10 ? text.slice(0, 10) : text
}

export function parseSkillTags(skills) {
  if (!skills) return []
  return skills.split(/[,，]/).map(item => item.trim()).filter(Boolean)
}

export function userInitial(nickname) {
  if (!nickname) return '?'
  return nickname.trim().charAt(0)
}

export function avatarColor(id) {
  const colors = ['#409eff', '#f59e0b', '#8b5cf6', '#10b981', '#ef4444', '#06b6d4']
  const index = Number(id || 0) % colors.length
  return colors[index]
}

export function formatUserCode(id) {
  if (id == null) return '-'
  return `U${String(id).padStart(3, '0')}`
}

export function formatPercent(part, total) {
  const t = Number(total || 0)
  if (t <= 0) return '0%'
  return `${((Number(part || 0) / t) * 100).toFixed(1)}%`
}
